module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO45QueEsPatrimonio.1687673.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO45QueEsPatrimonio.mp4
// module id = 771
// module chunks = 1